import { render, staticRenderFns } from "./Bookingsession.vue?vue&type=template&id=2b7f61e9&scoped=true&"
import script from "./Bookingsession.vue?vue&type=script&lang=js&"
export * from "./Bookingsession.vue?vue&type=script&lang=js&"
import style0 from "./Bookingsession.vue?vue&type=style&index=0&id=2b7f61e9&lang=scss&scoped=true&"
import style1 from "./Bookingsession.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f61e9",
  null
  
)

export default component.exports